import React, { useState } from "react";
import UsageOverviewPanel from "./UsageOverviewPanel";
import PlanFeaturesPanel from "./PlanFeaturesPanel";
import UpgradeRequestPanel from "./UpgradeRequestPanel";
import AutoScalePanel from "./AutoScalePanel";
import ScraperLimitsPanel from "./ScraperLimitsPanel";

type Tab = "usage" | "plan" | "autoscale" | "upgrade" | "scraper";

export default function BillingPage() {
  const [activeTab, setActiveTab] = useState<Tab>("usage");

  const tabClass = (tab: Tab) =>
    `pb-2 text-sm font-medium border-b-2 whitespace-nowrap ${
      activeTab === tab
        ? "border-cornflower-blue-500 text-cornflower-blue-600"
        : "border-transparent text-slate-500 hover:text-slate-700"
    }`;

  return (
    <div className="h-full overflow-y-auto">
      <div className="border-b border-slate-200 px-6 pt-4">
        <h1 className="text-lg font-semibold text-slate-gray-800 mb-3">Billing &amp; Usage</h1>
        <div className="flex gap-4 overflow-x-auto">
          <button className={tabClass("usage")} onClick={() => setActiveTab("usage")}>
            Usage Overview
          </button>
          <button className={tabClass("plan")} onClick={() => setActiveTab("plan")}>
            Plan &amp; Features
          </button>
          <button className={tabClass("autoscale")} onClick={() => setActiveTab("autoscale")}>
            Auto-Scale &amp; Alerts
          </button>
          <button className={tabClass("upgrade")} onClick={() => setActiveTab("upgrade")}>
            Contact Account Manager
          </button>
          <button className={tabClass("scraper")} onClick={() => setActiveTab("scraper")}>
            Web Scraper
          </button>
          <button
            className="pb-2 text-sm font-medium border-b-2 border-transparent text-slate-300 cursor-not-allowed whitespace-nowrap"
            disabled
            title="Coming soon"
          >
            Invoices
          </button>
        </div>
      </div>
      {activeTab === "usage" && <UsageOverviewPanel />}
      {activeTab === "plan" && <PlanFeaturesPanel />}
      {activeTab === "autoscale" && <AutoScalePanel />}
      {activeTab === "upgrade" && (
        <div className="p-6">
          <UpgradeRequestPanel />
        </div>
      )}
      {activeTab === "scraper" && <ScraperLimitsPanel />}
    </div>
  );
}
